import type { ClientDocumentWithPassportData } from '@/types/clientsApiTypes';

export const getMergedDocuments = (
  primaryPassengerDocuments: ClientDocumentWithPassportData[] = [],
  relatedPassengersDocuments: ClientDocumentWithPassportData[] = []
) => {
  const documentMap = new Map<number, ClientDocumentWithPassportData>();

  for (const doc of primaryPassengerDocuments) {
    if (typeof doc.id === 'number') {
      documentMap.set(doc.id, doc);
    }
  }

  for (const doc of relatedPassengersDocuments) {
    if (typeof doc.id === 'number' && !documentMap.has(doc.id)) {
      documentMap.set(doc.id, doc);
    }
  }

  return Array.from(documentMap.values());
};